<!-- 谈话记录 -->
<template>
  <div class="Crisis_major_consult">
    
    <el-form style="padding: 20px;" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="Content" placeholder="学号/姓名/身份证号"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>

    <div>
      <el-table v-loading="loadings" :data="data" style="width: 100%;margin-top:10px;width: 98%;margin-left: 1%;" :default-sort="{ prop: 'date', order: 'descending' }">
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.RealName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="学号">
            <template slot-scope="scope">
              <span>{{ scope.row.UserID }}</span>
            </template>
          </el-table-column>

          <el-table-column label="访谈日期">
            <template slot-scope="scope">
              <span>{{ scope.row.InterviewDate }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="访谈开始时间">
            <template slot-scope="scope">
              <span>{{ scope.row.InterviewTimeBegin }}</span>
            </template>
          </el-table-column>

          <el-table-column label="候补时间">
            <template slot-scope="scope">
              <span>{{ scope.row.CreateTime }}</span>
            </template>
          </el-table-column>

          <el-table-column label="手机号">
            <template slot-scope="scope">
              <span> {{ scope.row.Phone }}</span>
            </template>
          </el-table-column>

          <el-table-column label="身份证号">
            <template slot-scope="scope">
              <span>{{ scope.row.IDCard }}</span>
            </template>
          </el-table-column>

        </el-table>
    </div>
    <!-- currentPage1 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page.sync="pageIndex"  :page-size="10" layout="total, prev, pager, next" :total="Counts">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Content:'',
      ts:'',
      PaperList:[],
      dialogVisible:false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      fieldArray:[],
      SaveFlg: 1,
      value1: '',
      InterviewStatus: '4',
      loadings: true,
      interviewVisible: false,
      Counts:0,
      formInline: {
        UserID: '',
        Status: ''
      },
      Paperhead: {
        Name: '',
        Sex: '',
        DeptName: '',
        UserID: '',
        Result: '',
        PublishID: '',
        Remark: '',
        Age: '',
      },
      pageSize:10,
      pageIndex: 1,

      data:[]
    };
  },
  methods: {
    
    bg(res) {
      this.Paperhead.Name = res.RealName;
      this.Paperhead.Sex = res.Sex;
      this.$Http_Post('EmphasisClarification/GetPaperList', {PublishID: res.PublishID, UserID: res.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = true;
          this.PaperList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    gourl(res) {
      window.open(res.TencentLink);
    },

    handleClose(done) {
      this.$confirm(this.$t('original.languages60'))
        .then(_ => {
          done();
        })
        .catch(_ => {
        });
    },
    handleSizeChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.loading();
    },
    loading() {
      this.$Http_Post('/EmphasisClarification/GetCandidateList',{ Content :this.Content, pageSize:10, pageIndex : this.pageIndex }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          this.loadings = false;
          this.Counts = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  mounted() {
    this.loading();
    this.Paperhead.Remark = JSON.parse(localStorage.getItem('userInfo')).UserName;
    this.$Http_Post('CrisisWarning/GetPageList', { TableName: '新生心理普测访谈记录表' }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.fieldArray = res.Data.FormConfigurations;
        this.SaveFlg = res.Data.SaveFlg;
      }
    });
  },
  filters: {

  },
};
</script>
<style>
  .Crisis_major_consult{height: 100%;width: 100%;background-color: #fff;}
  tbody td{text-align: center !important;}
  .Crisis_major_consult .colrowspanbottomstyle {border-bottom: 1px solid rgba(225, 226, 227, 1);}
  .Crisis_major_consult .noneborder input {border: 0px;}

  .Crisis_major_consult .bottomborder input {
    border-bottom: 1px solid rgba(166, 166, 166, 1);
  }

  .Crisis_major_consult .el-dialog h2 {
    padding-top: 14px;
    margin-bottom: 14px;
  }

.Crisis_major_consult .el-dialog .标题 {
  width: 100%;
}

.Crisis_major_consult .el-dialog .el-form>div {
  margin-left: 14px;
}

.Crisis_major_consult .el-dialog .输入框 input {
  width: initial;
  width: 400px;
}
.Crisis_major_consult .el-textarea__inner{height: 80px !important;}

.Crisis_major_consult .el-dialog .el-input__inner {
  width: initial;
}
.el-dialog .填空题, .单选题, .时间选择, .文本域{padding: 6px;
    border: 1px solid rgb(235, 235, 235);
    margin-top: 4px;}
.Crisis_major_consult .el-dialog .el-form-item__label {
  width: initial !important;
  display: inline-block;
  text-align: right;
  min-width: 90px;
  text-align: left;
  width: 132px !important;
}
.Crisis_major_consult .el-dialog  .el-textarea{width: 350%;}
.Crisis_major_consult .el-dialog .el-form-item__content {
  margin-left: initial !important;
  display: inline-block;
}


.Crisis_major_consult .mild {
  padding: 0px 15px;
  background: rgba(29, 154, 255, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(29, 154, 255, 1);
}

.Crisis_major_consult .moderate {
  padding: 0px 15px;
  background: rgba(255, 193, 23, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(255, 193, 23, 1);
}

.Crisis_major_consult .severe {
  padding: 0px 15px;
  background: rgba(255, 141, 26, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(255, 141, 26, 1);
}

.Crisis_major_consult .well {
  padding: 0px 15px;
  background: rgba(21, 191, 109, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(21, 191, 109, 1);
}

.Crisis_major_consult .urgency {
  padding: 0px 15px;
  background: rgba(191, 41, 21, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgb(248, 4, 4);
}


</style>
